import React from 'react';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { useDispatch } from 'react-redux';
import thunk from 'redux-thunk';

const createReducerManager = initialReducers => {
  const reducers = { ...initialReducers };

  let combinedReducer = combineReducers(reducers);
  let keysToRemove = [];

  return {
    getReducerMap: () => reducers,
    reduce(state, action) {
      if (keysToRemove.length > 0) {
        // eslint-disable-next-line no-param-reassign
        state = { ...state };

        for (const key of keysToRemove) {
          // eslint-disable-next-line no-param-reassign
          delete state[key];
        }

        keysToRemove = [];
      }

      return combinedReducer(state, action);
    },
    add(key, reducer) {
      if (!key || reducers[key]) return;
      reducers[key] = reducer;
      combinedReducer = combineReducers(reducers);
    },
    remove(key) {
      if (!key || !reducers[key]) return;
      delete reducers[key];
      keysToRemove.push(key);
      combinedReducer = combineReducers(reducers);
    },
  };
};

const isOpenProdReduxTool = false;
export const configureStore = reducer => {
  const reducerManager = createReducerManager(reducer);
  let composeEnhancer;
  if (process.env.REACT_APP_NODE_ENV === 'production' || isOpenProdReduxTool) {
    composeEnhancer = compose;
  } else {
    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }

  const store = createStore(
    reducerManager.reduce,
    composeEnhancer(applyMiddleware(thunk)),
  );

  return store;
};

export const dynamic = (key, reducer, rootReducer) => WrappedComponent => {
  const reducerManager = createReducerManager(rootReducer);
  reducerManager.add(key, reducer);
  const Dynamic = props => {
    const dispatch = useDispatch();
    dispatch({ type: '@@redux/INIT' });
    return <WrappedComponent {...props} />;
  };

  return Dynamic;
};
